import { Middleware } from 'redux';

// Define the middleware
// Redux 5 trocou `AnyAction` por `UnknownAction`: o `action` chega tipado como `unknown`, e ler
// `.type` direto nao compila mais. O estreitamento abaixo substitui o acesso solto sem mudar o
// comportamento (o middleware so loga; nem esta ativo — ver `ativarTimingMiddleware` em store.ts).
const timingMiddleware: Middleware = () => (next) => (action) => {
    const startTime = Date.now();
    const result = next(action);
    const endTime = Date.now();
    const tipo = typeof action === 'object' && action !== null && 'type' in action
        ? String((action as { type: unknown }).type)
        : '(acao sem type)';
    console.log(`${tipo} took ${endTime - startTime}ms`);
    return result;
};

export {timingMiddleware}
